<script>
    import Chart from "chart.js/auto";
    import { Bar } from "svelte-chartjs";
    import { barDataset, barOptions, applyChartDefaults } from "./chartTheme";

    applyChartDefaults();

    export let data;

    $: options = {
        ...barOptions,
        plugins: {
            ...barOptions.plugins,
            legend: {
                ...barOptions.plugins.legend,
                display: ((data && data.datasets) || []).length > 1,
            },
        },
    };

    $: styled = {
        ...data,
        datasets: ((data && data.datasets) || []).map(barDataset),
    };
</script>

<div class="chart-box">
    <Bar data={styled} {options} />
</div>

<style>
    .chart-box {
        position: relative;
        height: 240px;
    }
</style>
